import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Alert, Checkbox, Form, Modal, Radio, Select } from '@maxtropy/components';
import { Popover } from 'antd';
import { useEffect, useState } from 'react';
import { EnergyItem, RecordItem } from './Create';
import { getDataQueryPeriodList } from '@/api/energyOverview';
import { apiV2AreaGetPlanMediumPost } from '@maxtropy/device-customer-apis-v2';

type Props = {
  areaId: number;
  closeModal: () => void;
  item: RecordItem;
  onSave: (updatedItem: RecordItem) => void;
};
type SelectProps = {
  label?: string;
  value?: number;
};
const content = '生产时段来源于用能时间台账，则取对应区域下各能源介质的用能计划和延时用能申请（审批完）时间范围内；';
const Edit = ({ areaId, closeModal, item, onSave }: Props) => {
  const [form] = Form.useForm();
  const [dataPeriodList, setDataPeriodList] = useState<SelectProps[]>();
  const [energyMediumList, setEnergyMediumList] = useState<SelectProps[]>();
  const timePeriodType = Form.useWatch('timePeriodType', form);

  const onFinish = (values: any) => {
    let updatedItem;
    if (values.timePeriodType === 1) {
      const selectedPeriod = dataPeriodList?.find(p => p.value === values.timePeriodDetailList);
      const timePeriodDetailList = selectedPeriod ? [{ id: selectedPeriod.value, name: selectedPeriod.label }] : [];
      updatedItem = {
        ...item,
        mediumId: item.mediumId,
        timePeriodType: 1,
        timePeriodDetailList,
      };
    } else {
      const selectedMediums = values.energyMediumIds;
      const timePeriodDetailList =
        energyMediumList
          ?.filter(p => selectedMediums.includes(p.value))
          .map(medium => ({
            id: medium.value,
            name: medium.label,
          })) || [];

      updatedItem = {
        ...item,
        mediumId: item.mediumId,
        timePeriodType: 2,
        timePeriodDetailList,
      };
    }

    onSave(updatedItem);
    closeModal();
  };

  useEffect(() => {
    // 回显
    if (item) {
      console.log(item);

      form.setFieldsValue({
        timePeriodType: item.timePeriodType ?? 1,
        ...(item.timePeriodType === 1
          ? { timePeriodDetailList: item.timePeriodDetailList?.[0]?.id }
          : { energyMediumIds: item.timePeriodDetailList?.map(p => p.id) || [] }),
      });
    } else {
      form.setFieldsValue({ timePeriodType: 1 });
    }
  }, [item]);

  // 数据查询时段
  useEffect(() => {
    getDataQueryPeriodList({}).then(res => {
      const data = res.dataPeriodList ?? [];
      const options = data.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setDataPeriodList(options);
    });
  }, []);

  //用能介质列表
  useEffect(() => {
    apiV2AreaGetPlanMediumPost({ areaId }).then(res => {
      const data = res.list ?? [];
      const options = data.map(item => ({
        value: item.energyMediumId,
        label: item.energyMediumName,
      }));
      setEnergyMediumList(options);
    });
  }, []);

  return (
    <Modal
      title="新增字段"
      contentClassName="modal-form-content"
      open={true}
      onCancel={() => closeModal()}
      onOk={() => form.submit()}
      confirmLoading={false}
    >
      <Form form={form} onFinish={onFinish}>
        <Form.Item name="timePeriodType" label="生产时段配置">
          <Radio.Group>
            <Radio value={1}>自定义时段</Radio>
            <Radio value={2}>
              来源用能台账时间
              <Popover content={content} overlayInnerStyle={{ width: 224 }}>
                <ExclamationCircleOutlined style={{ color: 'var(--warning-color)', padding: 4, marginLeft: 8 }} />
              </Popover>
            </Radio>
          </Radio.Group>
        </Form.Item>

        {timePeriodType === 1 && (
          <Form.Item name="timePeriodDetailList" label="数据查询时段">
            <Select allowClear placeholder="请选择" options={dataPeriodList} />
          </Form.Item>
        )}

        {timePeriodType === 2 && (
          <Form.Item name="energyMediumIds" label="选择申请介质">
            <Select allowClear placeholder="请选择" options={energyMediumList} mode="multiple" />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};
export default Edit;
